export class Competition {

  public id!: string;

  public name!: string;

  public domain!: string;

  public description?: string;

  public logoUrl?: string;

  public published?: boolean;

  public createdAt?: Date | null;

  public modifiedAt?: Date | null;

  public static parse(dto: CompetitionDto): Competition {
    const competition = new Competition();

    competition.id = dto.id || '';
    competition.name = dto.name || '';
    competition.domain = dto.domain || '';
    competition.description = dto.description;
    competition.logoUrl = dto.logo_url || 'assets/competitions-logo.svg';
    if (competition.domain == 'levenia') {
      competition.logoUrl = 'assets/levenia-logo.png';
    } else if (competition.domain == 'wombat') {
      competition.logoUrl = 'assets/wombat-logo.png';
    } else if (competition.domain == 'movoznavets') {
      competition.logoUrl = 'assets/movoznavets-logo.png';
    }
    competition.published = dto.published || false;
    competition.createdAt = dto.created_at ? new Date(dto.created_at) : null;
    competition.modifiedAt = dto.modified_at ? new Date(dto.modified_at) : null;

    return competition;
  }
}

export interface CompetitionDto {
  id?: string;

  name?: string;

  domain?: string;

  description?: string;

  logo_url?: string;

  published?: boolean;

  created_at?: number;

  modified_at?: number;
}
